//Polyfill
import "core-js";

//Can't resolve 'regenerator-runtime/runtime'が表示されたとき(async awaitを使う場合など)
//import  regeneratorRuntime  from  "regenerator-runtime" ;

import jQuery from "jquery";
import "magnific-popup";
const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)



$(document).ready(function() {
  // .header-btnがクリックされたときの処理
  $(".header-btn").click(function () {
    // .header-btnと.header-spのopenクラスをトグル（追加/削除）
    $(".header-btn, .header-sp").toggleClass("open");
  });

  //スマホの展開の挙動
  $(".header-sp--title").click(function(e) {
    // ウィンドウ幅が768px以下でない場合は処理を中断
    if ($(window).width() > 768) return;

    e.preventDefault();

    // クリックされた要素の隣にある .header-sp-box--inner を取得
    const $currentInner = $(this).next(".header-sp-box--inner");

    // 他の .header-sp-box--inner を閉じ、他のタイトルから active クラスを削除
    $(".header-sp-box--inner").not($currentInner).stop(true, true).slideUp();
    $(".header-sp--title").not(this).removeClass("active");

    // クリックされた要素の .header-sp-box--inner の表示状態を切り替え
    $currentInner.stop(true, true).slideToggle();
    $(this).toggleClass("active");
  });

  //ライトボックスプラグイン
  $(".popupgallery").magnificPopup({
    delegate: "a",
    type: "image",
    gallery: { //ギャラリー表示にする
      enabled: true,
      tCounter: "" //カウンターの値を空に'
    },
    image: {
      titleSrc: function (item) {
        return item.el.find("img").attr("alt");
      }
    }
  });
});

//イベントのスライダー
const swiper = new Swiper(".eventSwiper", {
  loop: true,
  slidesPerView: 1.2,
  spaceBetween: 15,
  centeredSlides: true,
  initialSlide: 1,
  breakpoints: {
    768: {
      loop: false,
      centeredSlides: false,
      initialSlide: 0,
      slidesPerView: 3,
      spaceBetween: 32,
    },
  },
});

const swiper = new Swiper(".studioSwiper", {
  loop: true,
  slidesPerView: 1.2,
  spaceBetween: 15,
  centeredSlides: true,
  initialSlide: 1,
  autoplay: {
    delay: 4000,
  },
  breakpoints: {
    768: {
      loop: false,
      centeredSlides: false,
      initialSlide: 0,
      slidesPerView: 3,
      spaceBetween: 32,
    },
  },
});

const swiper = new Swiper(".voiceSwiper", {
  loop: true,
  slidesPerView: 1.2,
  spaceBetween: 15,
  centeredSlides: true,
  initialSlide: 1,
  autoplay: {
    delay: 4000,
  },
  breakpoints: {
    768: {
      loop: false,
      centeredSlides: false,
      initialSlide: 0,
      slidesPerView: 3,
      spaceBetween: 32,
    },
  },
});

const swiper = new Swiper(".staffSwiper", {
  loop: true,
  slidesPerView: 1.8,
  spaceBetween: 15,
  centeredSlides: true,
  speed: 4000,
  allowTouchMove: false,
  autoplay: {
    delay: 0,
  },
  breakpoints: {
    768: {
      centeredSlides: true,
      initialSlide: 0,
      slidesPerView: 4,
      spaceBetween: 64,
    },
  },
});

const swiper = new Swiper(".blogSwiper", {
  loop: true,
  slidesPerView: 1.2,
  spaceBetween: 15,
  centeredSlides: true,
  initialSlide: 2,
  speed: 8000,
  allowTouchMove: false,
  autoplay: {
    delay: 0,
  },
  breakpoints: {
    768: {
      loop: false,
      centeredSlides: false,
      initialSlide: 0,
      slidesPerView: 4,
      spaceBetween: 32,
    },
  },
});

